module.exports = __webpack_public_path__ + "static/media/koroty.dbe4f765.png";